module.exports = __webpack_public_path__ + "static/media/nipomed.48148ae2.jpg";